import {
  LitElement,
  TemplateResult,
  property,
  customElement,
  css,
} from "lit-element";
import { html, render } from "lit-html";
import { storeInstance } from "store/index.js";
import "@ui5/webcomponents/dist/Button.js";
import "@ui5/webcomponents/dist/Dialog.js";
import "@ui5/webcomponents/dist/Label.js";
import "@ui5/webcomponents/dist/GroupHeaderListItem.js";
import "@ui5/webcomponents/dist/Input.js";

class KbDialogCart extends LitElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.subscription = storeInstance.subscribe((state) => {
      /*WexDialogFileProperties*/
      this.stateChange(state);
    });
    this.state = storeInstance.state;
    this.string = this.state.strings;
    this.itemFields = [];
    this.open = false;
    this.myRender();
    this.dialog = this.shadowRoot.querySelector("#cart-dialog");
  }

  disconnectedCallback() {
    storeInstance.unsubscribe(this.subscription);
  }

  stateChange(state) {
    this.state = state;
    this.string = this.state.strings;
    if (this.state.cart_dialog_open) {
      if (!this.open) {
        this.myRender();
        this.dialog.show();
        this.open = true;
      }
    } else {
      if (this.open) {
        this.open = false;
        this.dialog.close();
      }
    }
  }

  myRender() {
    this.dialogWidth = "60";
    this.dialogHeight = this.state.global_screen_specs.viewportHeight * 0.3;
    render(this.cartDialogTemplate(), this.shadowRoot);
  }

  closeDialog() {
    if (this.state.cart_dialog_open.callback) {
      this.state.cart_dialog_open.callback();
    }
    storeInstance.dispatch("setState", {
      property: "cart_dialog_open",
      value: null,
    });
  }

  cartDialogTemplate() {
    return html`
      <style>
        #cart-dialog{
            width:${this.dialogWidth}%;
            height:${this.dialogHeight}px;
            min-height: 30rem;
        }
        .cart-form{
            flex-direction: column;
            justify-content: space-evenly;
            align-items: flex-start;
            padding: 20px 20px 20px 20px;
        }

        .cartform > div {
            display: grid;
            width: 15rem;
            margin-bottom: .5rem;
        }
        [inner-input] {
            color: inherit;
            font-style: normal;
            -webkit-appearance: none;
            line-height: normal;
            box-sizing: border-box;
            min-width: 3rem;
            text-overflow: ellipsis;
            font-size: inherit;
            font-family: inherit;
            background: transparent;
            border-width: initial;
            border-style: none;
            border-color: initial;
            border-image: initial;
            flex: 1 1 0%;
            outline: none;
        }
        .dialog-footer{
            display: flex;
            align-items: center;
            padding: .5rem;
            }
        }
        .hide{display:none!important;}
        #message{
            margin:5px;width:90%;
        }
        ui5-label{
            text-align:left;
            padding-right: 10px;
        }
        ui5-button{
            margin:1rem;
            }
            table {
                width: 100%;
                text-align: left;
            }
        .hide(display:none;)
        .show(display:block;)
      </style>

      <ui5-dialog id="cart-dialog" header-text="${this.string["_cartdialog"]}">
        <section class="cart-form">
          <table>
            <thead>
              <tr>
                <th>Description</th>
                <th>Part number</th>
                <th>Quantity</th>
              </tr>
            </thead>
            <tbody>
              ${this.state.partcart.map((part) => this._tableRow(part))}
            </tbody>
          </table>
        </section>

        <div slot="footer" class="dialog-footer">
          <div style="flex: 1;"></div>
          <ui5-button
            id="closeDialogButton"
            design="Emphasized"
            @click="${this.closeDialog.bind(this)}"
            >${this.string["_ok"]}</ui5-button
          >
        </div>
      </ui5-dialog>
    `;
  }

  _validateNumber(e) {
    console.log(e.detail);
  }

  _tableRow(part) {
    return html`<tr>
      <td>${part.description}</td>
      <td>${part.partno}</td>
      <td>
        <ui5-input
          type="Number"
          id="${part.partno}"
          class="qty ui5-content-density-compact"
          value=""
          @change="${this._validateNumber.bind(this)}"
        >
        </ui5-input>
      </td>
    </tr>`;
  }
}

customElements.define("kb-dialog-cart", KbDialogCart);
